/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import * as React from "react";
import { SiteProvider } from "./src/context/site-context";
import { AnimatePresence } from "framer-motion";

export const wrapRootElement = ({ element }) => (
  <SiteProvider>{element}</SiteProvider>
);

export const wrapPageElement = ({ element }) => (
  <AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
);

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  window.history.scrollRestoration = "manual";
  // transition duration from `layout.js` * 1000 to get time in ms
  // * 2 for exit + enter animation
  const TRANSITION_DELAY = 0.8 * 1000;
  const savedPosition = [0, 0];
  window.setTimeout(
    () => window.scrollTo(...savedPosition),
    TRANSITION_DELAY
  );

  return false;
};
